import { logger } from '@/util/logger';

const $ = window.$;
window.lastPopupId;
window.lastPopupClickerId;
window.lastPDFViewerVis;
window.objReceiptViewerFullViewWindow = null;
window.isShowingPDF = false;

window.showReceiptViewerFullImage = function(strURL, isPDF) {
	var isBase64Image = strURL.indexOf('base64') > -1;

	if (isBase64Image) {
		//try to clear innerhtml in case we have previously written an image to the view full image window
		try {
			if (window.objReceiptViewerFullViewWindow.document && window.objReceiptViewerFullViewWindow.document.documentElement !== null) {
				window.objReceiptViewerFullViewWindow.document.documentElement.innerHTML = '';
			}
		} catch (err) {
			logger.log(err);
		}

		var img = new Image();
		img.src = strURL;
		window.objReceiptViewerFullViewWindow = window.open('', 'fileAtt', 'resizable=yes');
		window.objReceiptViewerFullViewWindow.document.documentElement.querySelector('body').appendChild(img);
		return;
	}

	if (!window.isShowingPdf || window.objReceiptViewerFullViewWindow === null || window.objReceiptViewerFullViewWindow.closed) {
		window.objReceiptViewerFullViewWindow = window.open(strURL, 'fileAtt', 'resizable=yes');
	} else {
		window.objReceiptViewerFullViewWindow.postMessage(strURL, window.location.origin);
	}

	window.isShowingPDF = isPDF;
};


window.findPosX = function(obj) {
	return $(obj).offset().left;
};

window.getUsableDocHeight = function() {
	return $(document).height() - $('.js-footer').outerHeight(true);
};

window.findPosY = function(obj) {
	return $(obj).offset().top;
};

window.hideLastPopup = function() {
	var objLast;
	var objCILast;
	var isHelpLast;
	objLast = document.getElementById(window.lastPopupId);
	objCILast = document.getElementById(window.lastPopupClickerId);
	isHelpLast = typeof lastPopupIsHelp !== 'undefined' ? window.lastPopupIsHelp : false;

	if (objLast && objCILast) {
		window.lastPopupId = '';
		window.lastPopupClickerId = '';
		if (objLast.style.visibility == 'visible') {
			window.showhidePopup(objLast.id, objCILast.id, isHelpLast);
		}
	}
};

window.showhidePopup = function(id, clickerId, isHelp) {
	var obj = document.getElementById(id);
	var objCI = document.getElementById(clickerId);
	var objLast;
	var objCILast;
    
	var popupHeight = obj.clientHeight;
	var posY = window.findPosY(objCI);
	var bottomPosition = posY + popupHeight;
	var overflowAmount = Math.max(bottomPosition - window.getUsableDocHeight(), 0);
    
	if (obj && objCI) {
		if (obj.style.visibility == 'hidden') {
			if ($(window).width() > 568) {
				if (window.findPosX(objCI) + $(objCI).outerWidth() + $(obj).width() >= $(window).width()) {
					obj.style.left = ($(window).width() - $(obj).width() - 8) + 'px';
				}
				else {
					obj.style.left = (window.findPosX(objCI) + $(objCI).outerWidth()) + 'px';
				}
			}
			else {
				obj.style.left = ($(window).width() / 2) - ($(obj).width() / 2) + 'px';
			}

			if (overflowAmount) {
				$('.js-body').css('padding-bottom', parseInt($('.js-body').css('padding-bottom')) + overflowAmount);
			}

			obj.style.top = posY + 'px';

			obj.style.position = 'absolute';
			obj.style.visibility = 'visible';
			obj.style.zIndex = 1000;
			if (isHelp == true) {
				objCI.src = 'images/icons-v2/help-20px.svg';
			} else {
				objCI.src = 'images/icons-v2/collapse-left-20px.svg';
			}
			objLast = document.getElementById(window.lastPopupId);
			objCILast = document.getElementById(window.lastPopupClickerId);
			if ((objLast && objCILast) && (objLast !== obj)) {
				window.lastPopupId = '';
				window.lastPopupClickerId = '';
				window.lastPopupIsHelp = '';
				if (objLast.style.visibility == 'visible') {
					window.showhidePopup(objLast.id, objCILast.id, isHelp);
				}
			}
			window.lastPopupId = id;
			window.lastPopupClickerId = clickerId;
			window.lastPopupIsHelp = isHelp;
		} else {
			obj.style.visibility = 'hidden';
			if (isHelp == true) {
				objCI.src = 'images/icons-v2/help-20px.svg';
			} else {
				obj.style.top = -3;
				objCI.src = 'images/icons-v2/collapse-right-20px.svg';
			}

			obj.style.left = 0;
			window.lastPopupId = '';
			window.lastPopupClickerId = '';
			window.lastPopupIsHelp = '';
		}
		window.showhidePDFViewer(obj);
	}
};

window.showhidePDFViewer = function(obj) {
	var objPDFViewerPanel;

	objPDFViewerPanel = document.getElementById('MainContent_PDFViewerPanel');

	if (objPDFViewerPanel) {
		if (obj.style.visibility == 'visible') {
			if ((objPDFViewerPanel.style.visibility == 'visible') || (objPDFViewerPanel.style.visibility == '')) {
				window.lastPDFViewerVis = objPDFViewerPanel.style.visibility;
				objPDFViewerPanel.style.visibility = 'hidden';
			}
		}
		else {
			if ((objPDFViewerPanel.style.visibility == 'hidden')) {
				objPDFViewerPanel.style.visibility = window.lastPDFViewerVis;
			}
		}
	}
};